import React, { useState, useEffect, useContext } from 'react';
import usePortalAuth from '../../../auth/usePortalAuth';

import { Link } from 'react-router-dom';
import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';
import MSSPCreatClientButton from './MSSPCreateClientButton';
import MSSPClientCard from './MSSPClientCard';
import MSSPClientCardTile from './MSSPClientCardTile';
import { useQuery } from 'react-query';
import { fetchOldApiData } from '../../../utils/service';
import basePCUrl from '../../../Globals';

//--------------Material UI Imports--------------//
import { createTheme, MuiThemeProvider, makeStyles, withStyles, useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import ViewListIcon from '@material-ui/icons/ViewList';
import Select from '@material-ui/core/Select';
import CloseIcon from '@material-ui/icons/Close';
import RefreshIcon from '@material-ui/icons/Refresh';


import './MSSP.css';
import MSSPReportGenButton from './MSSPReportGenButton';
import MSSPNewFeatureDialogue from './MSSPNewFeatureDialogue.js';
import useFilterForm from '../CustomHooks/useFilterForm';
import { ArrowRight } from '@material-ui/icons';
import useChangePageTitle from '../CustomHooks/useChangePageTitle';

const MSSPBaseView = (props) => {
  //Will need MSSP role/definer to pass down as props
  //Remove and/or alter sideNav for MSSP role/addOn

  useChangePageTitle('AccountManagement');
  const theme = useTheme();
  const isDark = theme.palette.type === 'dark';
  const pageTitleColor = isDark ? theme.palette.text.primary : '#1a237e';

  const { loading, getAccessTokenSilently, getAccessTokenWithPopup } = usePortalAuth();
  const [inputValue, setInputValue] = useState(props.selectedClient.name);
  const [clientCardData, setClientCardData] = useState([]);
  const [listView, setListView] = useState(false);
  const [lastUpdated, setLastUpdated] = useState(null);

  const accountAdminData = props.accountAdminData

  const [MSSPNewFeatureDialogueState, setMSSPNewFeatureDialogueState] = useState(false);

  const preferredLanguage = props.preferredLanguage
  const getTranslation = props.getTranslation

  const toggleMSSPNewFeatureDialogue = () => {
    setMSSPNewFeatureDialogueState(!MSSPNewFeatureDialogueState);
  };

  const [cardsPerRow, setCardsPerRow] = useState(6);

  const handleChange = (event) => {
    setCardsPerRow(event.target.value);
  };


  const clients = accountAdminData?.map((client) => {
    const firstLetter = client.companyName[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
      ...client,
    };
  });
  

  var currentlySelectedClient = props.selectedClient;

  const getClientCardData = async () => {

    const token = await getAccessTokenSilently();

    fetch(basePCUrl, {
      method: 'get',
      headers: { action: 'getAcctCards', 'content-type': 'application/json', Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        if (response.status !== 200) {
          console.log('Looks like there was a problem. Status Code: ' + response.status);
          //setError(true);
          return;
        }

        response.json().then((data) => {
          setClientCardData(data);
          setLastUpdated(new Date());
        });
      })
      .catch(function (err) {
        console.log('Fetch Error :-S', err);
      });
  };

  useEffect(() => {
    getClientCardData();
  }, []);

  //-------Handle Search Filter-------//

  const [values, handleFilterChange] = useFilterForm({
    filter: '',
  });

  let filter = values.filter;
  const lowercasedFilter = filter.toLowerCase();

  //Filter out null values so Object.keys doesn't throw and error
  var noNullForFilter = clientCardData?.map((el) => {
    return Object.keys(el).reduce((newObj, key) => {
      const value = el[key];
      if (value !== null) {
        newObj[key] = value;
      }
      return newObj;
    }, {});
  });

  const filteredData = noNullForFilter.filter((item) => {
    return Object.keys(item)
      .filter(Boolean)
      .some((key) => item[key].toString().toLowerCase().includes(lowercasedFilter));
  });


  const useStyles = makeStyles({
    header: {
      fontFamily: 'Montserrat, sans-serif',
      //fontWeight: 300
    },
    formControl: {
      minWidth: 130,
    },
    listViewButton: {},
    dialogueTitleRoot: {
      margin: 0,
      width: 500,
      height: 70,
      textAlign: 'center',
    },
    closeButton: {
      float: 'right',
    },
  });

  const classes = useStyles();


  const returnFormattedSparklineData = (dates, firstArray, secondArray) => {
    var initialArray = [];

    !secondArray ? (initialArray = [dates, firstArray]) : (initialArray = [dates, firstArray, secondArray]);

    let numberOfDataPoints = initialArray.length;

    var combinedArray = [];
    var finalArray = [];

    for (var i = 0; initialArray.length !== 0; i++) {
      var j = 0;
      while (j < initialArray.length) {
        if (i >= initialArray[j].length) {
          initialArray.splice(j, 1);
        } else {
          combinedArray.push(initialArray[j][i]);
          j += 1;
        }
      }
    }

    while (combinedArray.length > 0) {
      let chunk = combinedArray.splice(0, numberOfDataPoints);
      finalArray.push(chunk);
    }

    finalArray[0].length === 3
      ? finalArray.unshift(['x', 'high alerts', 'medium alerts'])
      : finalArray.unshift(['dates', 'active users']);

    return finalArray;
  };

  const newFeatureDialogueContents = () => {
    return (
      <div style={{ height: '100px', alignItems: 'center' }}>
        <DialogTitle />
        <p> {getTranslation("This feature will be coming in the future!", preferredLanguage)} </p>
      </div>
    );
  };

  const DialogTitle = () => {
    return (
      <MuiDialogTitle disableTypography>
        {toggleMSSPNewFeatureDialogue ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={toggleMSSPNewFeatureDialogue}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  };

  const getCurrentltySelectedClientName =(currentlySelectedClient)=> {
    const company = accountAdminData.find(company => company.clientId === currentlySelectedClient);
    return company ? company.companyName : null;

  }

  

  return (
    <div>
      <Paper
        style={{
          borderRadius: 16,
          boxShadow: '0 2px 20px rgba(0,0,0,0.07)',
          padding: '16px 24px',
          marginBottom: 24,
          backgroundColor: isDark ? '#1E1E1E' : undefined,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', marginBottom: 16 }}>
          <Typography
            style={{
              fontFamily: 'Montserrat, sans-serif',
              fontWeight: 700,
              fontSize: '1.6rem',
              color: pageTitleColor,
            }}
          >
            {getTranslation('Account Management', preferredLanguage)}
          </Typography>

          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Tooltip title={getTranslation('Refresh', preferredLanguage)}>
              <IconButton
                onClick={getClientCardData}
                size="small"
                style={{ backgroundColor: 'rgba(63, 81, 181, 0.08)' }}
              >
                <RefreshIcon style={{ color: '#3f51b5', fontSize: '1.1rem' }} />
              </IconButton>
            </Tooltip>
            <Typography style={{ fontSize: '0.8rem', color: '#999', fontFamily: 'Montserrat, sans-serif' }}>
              {lastUpdated ? lastUpdated.toLocaleTimeString() : '—'}
            </Typography>
          </div>
        </div>

        {!loading && accountAdminData.length !== 0 ? (
          <Grid container justify="center" alignItems="center" spacing={2} style={{ flexWrap: 'wrap' }}>
            <Grid item>
              {accountAdminData[0]?.companyName != 'no client selected' ? (
                <Autocomplete
                  disableClearable
                  options={clients.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
                  noOptionsText={getTranslation('No Matching Clients', preferredLanguage)}
                  groupBy={(client) => client.firstLetter}
                  getOptionLabel={(client) => (typeof client === 'string' ? client : client.companyName)}
                  style={{ maxWidth: 400, minWidth: 200, height: '100%' }}
                  value={getCurrentltySelectedClientName(currentlySelectedClient)}
                  onChange={(event, newValue) => {
                    console.log(newValue.clientId)
                    props.setSelectedClient(newValue.clientId)
                  }}
                  renderInput={(params) => <TextField {...params} variant="outlined" style={{ height: '56px' }} />}
                />
              ) : (
                <LoadingSpinner />
              )}
            </Grid>
            <Grid item>
              <Link to={'/Dashboard/CompanyOverview'}>
                <Button variant="contained" style={{ height: '56px', backgroundColor: '#3f51b5', color: '#fff' }} disableElevation>
                  {getTranslation('Go', preferredLanguage)}
                </Button>
              </Link>
            </Grid>
            <Grid item>
              <MSSPCreatClientButton
                toggleMSSPNewFeatureDialogue={toggleMSSPNewFeatureDialogue}
                MSSPNewFeatureDialogueState={MSSPNewFeatureDialogueState}
                preferredLanguage={props.preferredLanguage}
                getTranslation={getTranslation}
              />
            </Grid>
            <Grid item>
              <MSSPReportGenButton
                toggleMSSPNewFeatureDialogue={toggleMSSPNewFeatureDialogue}
                MSSPNewFeatureDialogueState={MSSPNewFeatureDialogueState}
                preferredLanguage={props.preferredLanguage}
                getTranslation={getTranslation}
              />
            </Grid>
            <Grid item>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="demo-simple-select-outlined-label">{getTranslation('Cards', preferredLanguage)}</InputLabel>
                <Select labelId="cards per row" value={cardsPerRow} onChange={handleChange} label="Cards">
                  <MenuItem value={12}>1</MenuItem>
                  <MenuItem value={6}>2</MenuItem>
                  <MenuItem value={4}>3</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item>
              <Tooltip title={getTranslation('List View', preferredLanguage)}>
                <IconButton
                  aria-label="View as List"
                  className={classes.listViewButton}
                  onClick={() => setListView(!listView)}
                >
                  <ViewListIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        ) : null}
      </Paper>

      <Grid container spacing={4} alignItems="flex-end" justify="flex-start" direction="row">
        {/* {props.clientList.map(value => ( */}
        {clientCardData !== undefined && !clientCardData.hasOwnProperty('error')
          ? clientCardData?.map((value, idx) => (
              <MSSPClientCard
                key={`${value}-${idx}`}
                preferredLanguage={preferredLanguage}
                getTranslation={getTranslation}
                history={props.history}
                cardsPerRow={cardsPerRow}
                listView={listView}
                clientId={value.clientId}
                toggle={toggleMSSPNewFeatureDialogue}
                setSelectedClient={props.setSelectedClient}
                companyLogo={value.companyLogo}
                companyName={value.companyName}
                companyContact={value.companyContact}
                lastContactDate={value.lastContactDate}
                riskLevel={value.companyRiskLevel}
                activeAlertTotal={value.totalActiveAlerts}
                alertScore={value.activeAlerts.alertScore}
                activeUserScore={value.activeUsers.activeUserScore}
                chartDataAlerts={returnFormattedSparklineData(
                  value.activeAlerts.dates,
                  value.activeAlerts.highAlerts,
                  value.activeAlerts.medAlerts
                )}
                chartDataActiveUsers={returnFormattedSparklineData(
                  value.activeUsers.dates,
                  value.activeUsers.numActiveUsers
                )}
                threatModel={value.threatModel}
              />
            ))
          : null}

        <MSSPNewFeatureDialogue
          toggle={toggleMSSPNewFeatureDialogue}
          isOpen={MSSPNewFeatureDialogueState}
          content={newFeatureDialogueContents()}
          preferredLanguage={props.preferredLanguage}
          getTranslation={getTranslation}
        />
      </Grid>
    </div>
  );
};
export default MSSPBaseView;

